module.exports = __webpack_public_path__ + "img/RedteaSIM_ZH02.adaf9b1a.jpg";